import React, { useState } from 'react';
import Styles from './CarrosEletricosBannerImgButton.css';
import RedButton from '../../atoms/RedButton';
import Container from '../../atoms/Container';

function CarrosEletricosBannerImgButton() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section className={'banner_mobile'}>
        <div className="img-container">
          <a
            href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:banner&int_campaign=simular#/dados-pessoais"
            target="_blank"
            rel="noopener"
          >
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 600 && (
                  <picture>
                    <source
                      type="image/png"
                      srcSet="assets/carros-eletricos/banner-sustentabilidade/banner-600.png"
                    />
                    <img
                      src="assets/carros-eletricos/banner-sustentabilidade/banner-600.png"
                      alt="Financiamento de carro Elétrico. Você economiza enquanto contribui para o meio ambiente. Simular"
                      className="img-992 rp"
                    />
                  </picture>
                )}
                {width > 600 && width <= 992 && (
                  <picture>
                    <source
                      type="image/png"
                      srcSet="assets/carros-eletricos/banner-sustentabilidade/banner-992.png"
                    />
                    <img
                      src="assets/carros-eletricos/banner-sustentabilidade/banner-992.png"
                      alt="Financiamento de carro Elétrico. Você economiza enquanto contribui para o meio ambiente. Simular"
                      className="img-1320"
                    />
                  </picture>
                )}
              </>
            )}
          </a>
        </div>
        <RedButton
          href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:banner&int_campaign=simular#/dados-pessoais"
          id="simular-banner-mobile"
          target="_blank"
          rel="noopener"
        >
          Simular
        </RedButton>
      </section>

      <section className={'banner_desk'}>
        <Container>
          <div className="img-container">
            <a
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:banner&int_campaign=simular#/dados-pessoais"
              target="_blank"
              rel="noopener"
            >
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width <= 1200 && (
                    <picture>
                      <source
                        type="image/png"
                        srcSet="assets/carros-eletricos/banner-sustentabilidade/banner-1320.png"
                      />
                      <img
                        src="assets/carros-eletricos/banner-sustentabilidade/banner-1320.png"
                        alt="Financiamento de carro Elétrico. Você economiza enquanto contribui para o meio ambiente. Simular"
                        className="img-600"
                      />
                    </picture>
                  )}
                  {width > 1200 && (
                    <picture>
                      <source
                        type="image/png"
                        srcSet="assets/carros-eletricos/banner-sustentabilidade/banner-2650.png"
                      />
                      <img
                        src="assets/carros-eletricos/banner-sustentabilidade/banner-2650.png"
                        alt="Financiamento de carro Elétrico. Você economiza enquanto contribui para o meio ambiente. Simular"
                        className="img-992 rp"
                      />
                    </picture>
                  )}
                </>
              )}
            </a>
            <RedButton
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:banner&int_campaign=simular#/dados-pessoais"
              id="simular-banner-desktop"
              target="_blank"
              rel="noopener"
            >
              Simular
            </RedButton>
          </div>
        </Container>
      </section>
      {/* <Container>
        <p className={'banner_disclaimer'}>
          <a href="https://www.byd.com/br/condicoes" target="_blank" rel="noopener">
            Clique aqui
          </a>{' '}
          e confira as condições legais
        </p>
      </Container> */}
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosBannerImgButton;
